import React, { useEffect, useState } from "react";
import {
  CalendarIcon,
  HomeIcon,
  PencilIcon,
  SettingIcon,
  UsersIcon,
  VerifiedIcon,
} from "../Icons";
import { Button } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

const SideBar = () => {
  const [active, setActive] = useState("Home");

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const menu = [
    {
      title: "Home",
      link: "/home",
      icon: <HomeIcon />,
    },
    {
      title: "Page 1",
      link: "/page1",
      icon: <UsersIcon />,
    },
    {
      title: "Page 2",
      link: "/page2",
      icon: <VerifiedIcon />,
    },
    {
      title: "Page 3",
      link: "/page3",
      icon: <PencilIcon />,
    },
    {
      title: "Page 4",
      link: "/page4",
      icon: <CalendarIcon />,
    },
    {
      title: "Page 5",
      link: "/page5",
      icon: <SettingIcon />,
    },
  ];

  const handleMenu = (item) => {
    setActive(item.title);
    if (item.title === "Home") {
      navigate(item.title === "Home" ? "/" : item.link);
    }
  };

  useEffect(() => {
    const pathMap = {
      "/": "Home",
      "/profile-setting": "Profile Setting",
      // Add more paths here
    };

    setActive(pathMap[pathname] || "");
  }, [pathname]);

  return (
    <div className="mainSideBar">
      <div className="logoBox">
        <img
          src={require("../../assets/images/rise-logo.png")}
          alt="Logo"
          onClick={() => navigate("/")}
        />
      </div>
      <div className="menuList">
        {menu.map((item, index) => {
          return (
            <Button
              className={active === item.title ? "activeMenu" : ""}
              key={index}
              onClick={() => handleMenu(item)}
            >
              {item.icon}
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default SideBar;
